import { gql } from '@apollo/client';
import { useQuery } from '@tbitop/api';
import { useGraphQLErrorHandler } from '@tbitop/error-handling';
import { defaultTo } from 'lodash-es';
import type { VerfuegbareObjekteQuery } from './__generated__/VerfuegbareObjekteQuery';

export type { VerfuegbareObjekteFragment as Objekt } from './__generated__/VerfuegbareObjekteQuery';

export const useVerfuegbareObjekteQuery = () => {
  const { handleWithErrorNotification } = useGraphQLErrorHandler();
  const { data, loading, error } = useQuery<VerfuegbareObjekteQuery>(gql`
    query VerfuegbareObjekte {
      verfuegbareObjekte {
        ...VerfuegbareObjekte
      }
    }
    fragment VerfuegbareObjekte on Objekt {
      nummer
      name
      id
    }
  `, {
    onError: handleWithErrorNotification('Die Liste der Objekte konnte nicht geladen werden.'),
  });

  return {
    data: defaultTo(data?.verfuegbareObjekte, []),
    loading,
    error,
  };
};
